import styled from 'styled-components';

export const _MultipleChoiceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontFamilyPrimary};
  margin-bottom: 16px;
  font-size: 18px;

  div {
    display: flex;
    align-items: center;

    input[type='checkbox'] {
      cursor: pointer;
      accent-color: ${(props) => props.theme.black};
      margin: 4px 8px 4px 0px;
      height: 22px;
      width: 22px;
      border-width: 5px;
    }
  }
`;
